<kendo-dialog-titlebar class="flex items-center bg-background px-4 py-5" (close)="close()">
    <div class="flex w-full items-center justify-between pr-2">
        <div class="flex items-center gap-2">
            <ng-icon name="faSolidEnvelopeOpen" size="18px" />
            <span class="text-base font-semibold">{{ 'Message' | translate }}</span>
        </div>
        <app-button
            [variant]="copied ? 'success' : 'secondary'"
            [icon]="copied ? 'faSolidCheck' : 'faSolidCopy'"
            [tooltip]="(copied ? 'Copied!' : 'Copy to clipboard') | translate"
            (clicked)="copyToClipboard()" />
    </div>
</kendo-dialog-titlebar>

<div class="flex size-full flex-col overflow-hidden p-4">
    <pre
        class="flex-1 overflow-auto rounded-md border border-slate-200 bg-slate-50 p-4 text-xs leading-5 text-slate-800"
        style="font-family: 'Cascadia Code', 'Fira Code', 'Consolas', monospace"
    ><code [innerHTML]="highlightedMessage"></code></pre>
</div>

<kendo-dialog-actions layout="end" class="px-4">
    <app-button variant="secondary" (clicked)="close()">
        {{ 'Close' | translate }}
    </app-button>
</kendo-dialog-actions>
